export default [
  ['blob', { url: url => url, method: 'get', responseType: 'blob', raw: true }],

  ['upload', { url: '/common/upload', method: 'post' }],
  ['feedbackCreate', { url: '/mobile/feedback/create', method: 'post'},'formdata'],

  ['image', { url: (path, type) => `/common/image?path=${path}&type=${type}`, method: 'get', responseType: 'blob', raw: true }],
  ['systems', { url: '/uc/common/systems', method: 'get' }],
  // ['common_company', { url: '/common/queryCompanys', method: 'get' }],
  ['common_company', { url: '/common/queryRelativeCompanys', method: 'get' }],
  ['common_org', { url: '/common/queryOrgs', method: 'get' }],
  ['common_role', { url: '/uc/role/queryAll', method: 'get' }],
  ['sms',{url:'/common/query/super/send/',method:'post'}],
  ['phone',{url:'/common/query/super/user',method:'get'}],

  ['org_tree', { url:(role) => '/monitor/organization/tree', method: 'get' ,access:true }],
  ['common_carcate', { url: '/common/carCate', method: 'get' }],
  ['common_carcate_used',{url:'/common/carCate/old', method: 'get' }],
  ['common_brand', { url: `/brand/type/0`, method: 'get' }],
  ['common_brand:name', { url: `/brand/type/0`, method: 'get' }],
  // ['common_company', { url: 'company/info/queryPage', method: 'post' , data:{search:{},pageSize:9999,pageNum:1}}],
  ['brands', { url: (type) => `/brand/type/${type}`, method: 'get' }],
  ['district', { url: '/district', method: 'get' }],
  ['kv', { url: (cType) => `/configKv/${cType}`, method: 'get' }],

  // ['pay', { url: '/ali/pay', method: 'post' }],
  ['pay', { url: '/car/pay', method: 'post' }],

  ['signin', { url: '/uc/login', method: 'post', raw: true, token: false }],
  ['signout', { url: '/uc/logout', method: 'post' }],
  ['userinfo', { url: '/uc/common/userInfo', method: 'get' }],
  ['permissions', { url: '/uc/common/permission', method: 'get' }],
  ['passwordUpdate', { url: '/uc/user/updateSelfPassword', method: 'post' }],
  ['profile', { url: '/uc/common/user/company', method: 'get' }],
  ['profileUpdate', { url: '/uc/user/updateSelfById', method: 'post' }],

  ['module', { url: (id) => (`/uc/model/${id}`), method: 'get' }],
  ['modules', { url: '/uc/model/queryPage', method: 'post' }],
  ['moduleSelect', { url: '/uc/model/query/all', method: 'get' }],
  ['moduleUpdate', { url: '/uc/model/update', method: 'post' }],
  ['moduleCreate', { url: '/uc/model/create', method: 'post' }],
  ['moduleDelete', { url: (id) => (`/uc/model/${id}`), method: 'delete' }],

  ['menu', { url: id => `/uc/menu/${id}`, method: 'get' }],
  ['menus', { url: '/uc/menu/queryPersonal', method: 'get' }],
  ['menuQueryAll', { url: '/uc/menu/queryAll', method: 'get' }],
  ['menuCreate', { url: '/uc/menu/create', method: 'post' }],
  ['menuDelete', { url: '/uc/menu/delete', method: 'post' }],
  ['menuUpdate', { url: '/uc/menu/update', method: 'post' }],

  ['role', { url: (id) => (`/uc/role/${id}`), method: 'get' }],
  ['roles', { url: '/uc/role/queryPage', method: 'post' }],
  ['roleUpdate', { url: '/uc/role/update', method: 'post' }],
  ['roleCreate', { url: '/uc/role/create', method: 'post' }],
  ['roleDelete', { url: (id) => (`/uc/role/delete/${id}`), method: 'delete' }],
  ['roleDeleteBatch', { url: '/uc/role/deleteBatch', method: 'post' }],


  ['userDelete', { url: (id) => (`/uc/user/${id}`), method: 'delete' }],
  ['userCreate', { url: '/uc/user/create', method: 'post' }],
  ['user', { url: (id) => (`/uc/user/${id}`), method: 'get' }],
  ['users', { url: '/uc/user/page', method: 'post' }],
  ['userUpdate', { url: '/uc/user/update', method: 'post' }],
  ['userToggle', { url: '/uc/user/updateStates', method: 'post' }],
  ['userUnlock', { url: id => `/uc/user/updateLock/${id}`, method: 'put' }],

  ['sysUser', { url: (id) => (`/uc/user/sys/${id}`), method: 'get' }],
  ['sysUsers', { url: '/uc/user/sys/page', method: 'post' }],
  ['sysUserDelete', { url: (id) => (`/uc/user/sys/${id}`), method: 'delete' }],
  ['sysUserCreate', { url: '/uc/user/sys', method: 'post' }],
  ['sysUserUpdate', { url: '/uc/user/sys', method: 'put' }],
  ['sysUserToggle', { url: '/uc/user/sys/state', method: 'put' }],
  ['sysUserUnlock', { url: id => `/uc/user/sys/unlock/${id}`, method: 'put' }],



  ['courier', { url: (id) => (`/courier/query/${id}`), method: 'get' }],
  // ['couriers', { url: '/courier/queryPage', method: 'post' }],
  ['couriers', { url: '/courier/queryComplact', method: 'post' }],
  ['courierUpdate', { url: '/courier/update', method: 'post' }],
  ['courierCreate', { url: '/courier/create', method: 'post' }],
  ['courierDelete', { url: (id) => (`/courier/delete/${id}`), method: 'delete' }],
  ['courierToggle', { url: (id, status) => (`/courier/state/${id}?status=${status}`), method: 'put' }],
  ['courierImport', { url: '/courier/create/imports', method: 'post' }],
  ['courierGroupByCompanyId', { url: (id) => (`/courier/queryGroups/${id}`), method: 'get' }],
  //['courierCompanies', { url: `/courier/queryCompanys`, method: 'post' }],
  ['courierExamTpl', { url: id => `/courier/query/template/${id}`, method: 'get' }],
  ['courierExamReview', { url: '/courier/update/exam/review', method: 'put' }],
  ['courierExamRelease', { url: id => `/exam/cert/release/${id}`, method: 'get' }],
  ['courierExamReleaseBatch',{url:'/exam/cert/release/batch' , method:'post'}],
  ['courierExamRecords',{url:'/courier/query/applies' , 'method':'post'}],
  ['courierLicense',{url:id => `/courier/license/cert/queryPage` , 'method':'post'}],
  ['courierLicenses',{url:id => `/courier/license/cert/queryPage` , 'method':'post'}],
  ['courierLicenseRecord',{url:'/courier/query/punishes' , 'method':'post'}],
  ['courierExamRecord',{url:id=>`/exam/papers/queryByRecordId?id=${id}` , 'method':'get'}],
  ['courierExport', { url: '/courier/query/export', method: 'post' , responseType: 'blob',raw: true}],
  ['courierPush',{url:'/courier/migrate' , 'method':'post'}],


  //企业信息
  ['company', { url: (id) => (`/company/info/${id}`), method: 'get' }],
  // ['companies', { url: '/company/info/queryPage', method: 'post' }],
  // 1 监管
  // /enterprise/company/queryPage
  ['companies', { url:(userType) => ({3:`/company/info/queryPage` , 4:`/monitor/company/queryPage` , 5:`/enterprise/company/queryPage`})[userType], method:'post',access:true}],


  ['companiesByParent', { url: '/company/info/queryChildPage', method: 'post' }],
  ['companyCreate', { url: '/company/info/', method: 'post' }],
  ['companyUpdate', { url: '/company/info/', method: 'put' }],
  ['companyToggle', { url: (id) => (`/company/info/state/${id}`), method: 'put' }],
  ['companyReview', { url: '/company/change/apply/approval', method: 'post' }],
  ['companyCommit', { url: id => `/company/change/apply/${id}`, method: 'get' }],
  ['companyLastCommit', { url: companyId => `/company/change/apply/query/last/${companyId}`, method: 'get' }],
  ['companyCommits', { url: companyId => `/company/change/apply/queryList/${companyId}`, method: 'get' }],
  ['companyChange', { url: '/company/change/apply', method: 'post' }],
  ['companyExport', { url: '/company/info/query/export', method: 'post' , responseType: 'blob',raw: true }],
  ['companyImport', { url: '/company/info/imports', method: 'post' }],
  

  ['companyWarnings', { url: '/company/warn/queryPage', method: 'post' }],
  ['companyWarning', { url: id => `/company/warn/${id}`, method: 'get' }],
  ['companyWarningCreate', { url: '/company/warn', method: 'post' }],
  ['companyWarningUpdate', { url: '/company/warn', method: 'put' }],
  ['companyWarningDelete', { url: id => `/company/warn/${id}`, method: 'delete' }],
  ['companyWarningToggle', { url: (id) => (`/company/warn/state/${id}`), method: 'put' }],
  
  //企业分组
  ['companyGroup', { url: (id) => (`/company/group/${id}`), method: 'get' }],
  ['companyGroups', { url: '/company/group/queryPage', method: 'post' }],
  ['companyGroupCreate', { url: '/company/group/', method: 'post' }],
  ['companyGroupUpdate', { url: '/company/group/', method: 'put' }],
  ['companyGroupDelete', { url: (id) => (`/company/group/${id}`), method: 'delete' }],

  ['companyUser', { url: (id) => (`/company/user/${id}`), method: 'get' }],
  ['companyUsers', { url: '/company/user/queryPage', method: 'post' }],
  ['companyUserUpdate', { url: '/company/user', method: 'put' }],
  ['companyUserCreate', { url: '/company/user', method: 'post' }],
  ['companyUserDelete', { url: (id) => (`/company/user/${id}`), method: 'delete' }],
  ['companyUserToggle', { url: (id) => (`/company/user/updateStatus/${id}`), method: 'get' }],
  ['companyUserImport', { url: '/company/user/imports', method: 'post' }],

  ['compayUpdatePhotoByOrg',{url:'/monitor/company/net/photo' , method:'put'}],
  
  ['companyInspectionType', { url: (id) => (`/company/inspection/${id}`), method: 'get' }],
  ['companyInspectionTypes', { url: '/company/inspection/queryPage', method: 'post' }],
  ['companyInspectionTypeCreate', { url: '/company/inspection', method: 'post' }],
  ['companyInspectionTypeUpdate', { url: '/company/inspection', method: 'put' }],
  ['companyInspectionTypeDelete', { url: (id) => (`/company/inspection/${id}`), method: 'delete' }],

  ['companyInspection', { url: (id) => (`/company/inspection/record/${id}`), method: 'get' }],
  ['companyInspections', { url: '/company/inspection/record/queryPage', method: 'post' }],
  ['companyInspectionCreate', { url: '/company/inspection/record', method: 'post' }],
  ['companyInspectionUpdate', { url: '/company/inspection/record', method: 'put' }],
  ['companyInspectionDelete', { url: (id) => (`/company/inspection/record/${id}`), method: 'delete' }],

  ['companyDevice', { url: (id) => (`/company/device/${id}`), method: 'get' }],
  ['companyDevices', { url: '/company/device/queryPage', method: 'post' }],
  ['companyDeviceCreate', { url: '/company/device', method: 'post' }],
  ['companyDeviceUpdate', { url: '/company/device', method: 'put' }],
  ['companyDeviceDelete', { url: (id) => (`/company/device/${id}`), method: 'delete' }],
  ['companyDeviceLive', { url: (id) => (`/company/device/live/${id}`), method: 'get' }],

  ['car', { url: (id) => (`/car/info/query/${id}`), method: 'get' }],
  // ['cars', { url: '/car/info/queryPage', method: 'post' }],
  // ['cars', { url: '/car/info/querySelective', method: 'post' }],
  ['cars', { url:(userType) => ({3:`/car/info/querySelective` , 4:`/monitor/querySelective` , 5:`/enterprise/querySelective`})[userType], method:'post',access:true}],

  ['carsMap', { url:(userType) => ({3:`/car/info/queryMap` , 4:`/monitor/car/queryMap` , 5:`/enterprise/car/queryMap`})[userType], method:'post',access:true }],
  ['carImport', { url: '/car/info/create/imports', method: 'post' }],
  ['carExport', { url: '/car/info/query/export', method: 'post' , responseType: 'blob',raw: true}],

  ['carsLite', { url:(userType) => ({3:`/car/info/queryMap` , 4:`/monitor/queryTreeSearch` , 5:`/enterprise/car/queryMap`})[userType], method:'post',access:true }],
  ['carPush', { url: '/car/info/migrate', method: 'put' }],
  ['carPushConfirm', { url: '/car/info/migrate/confirm', method: 'post' }],


  ['carsInMap', { url: '/car/info/querySelective', method: 'post' }],

  ['carUpdate', { url: '/car/info/update', method: 'put' }],
  ['carCreate', { url: '/car/info/create', method: 'post' }],
  ['carDelete', { url: (id) => (`/car/info/delete/${id}`), method: 'delete' }],
  ['carEnable', { url: '/car/info/enable', method: 'put' }],
  ['carTurn', { url: '/car/info/updateStart', method: 'put' }],
  ['carUnbind', { url: id => `/car/info/updateBinded/${id}`, method: 'put' }],
  ['carLock', { url: id => `/car/info/updateLock`, method: 'put' }],
  ['carLockForCredit', { url: id => `/car/info/updateDeductlock`, method: 'put' }],

  ['carEnableBatch', { url: '/car/info/updateEnableBatch', method: 'put' }],
  ['carLockBatch', { url: '/car/info/updateLockBatch', method: 'put' }],
  ['carCreditLockBatch', { url: '/car/info/updateDeductlockBatch', method: 'put' }],
  ['carStartBillingBatch', { url: '/car/billing/updateBatchStart', method: 'post' }],

  

  ['carIdleImei', { url: `/car/info/queryBind`, method: 'post' }],

  ['carStock', { url: (id) => (`/car/storage/query/${id}`), method: 'get' }],
  ['carsStock', { url:(role) => '/car/storage/querySelective', method: 'post'}],
  ['carStockImport', { url: '/car/storage/create/imports', method: 'post' }],

  ['carStockUpdate', { url: '/car/storage/update', method: 'put' }],
  ['carStockCreate', { url: '/car/storage/create', method: 'post' }],
  ['carStockDelete', { url: (id) => (`/car/storage/delete/${id}`), method: 'delete' }],
  ['carStockEnable', { url: '/car/storage/enable', method: 'put' }],
  ['carStockTurn', { url: '/car/storage/updateStart', method: 'put' }],
  ['carStockLock', { url: id => `/car/storage/updateLock`, method: 'put' }],
  ['carStockDeliver', { url: `/car/storage/outStorage`, method: 'put' }],

  ['carCate', { url: (id) => (`/car/category/${id}`), method: 'get' }],
  ['carCates', { url: '/car/category/queryPage', method: 'post' }],
  ['carCateUpdate', { url: '/car/category', method: 'put' }],
  ['carCateCreate', { url: '/car/category', method: 'post' }],
  ['carCateDelete', { url: (id) => (`/car/category/${id}`), method: 'delete' }],

  ['carLog', { url: (id) => (`/car/use/query/${id}`), method: 'get' }],
  ['carChangelog', { url: (userType,carNo) => ({3:`/car/info/car/changeApply/${carNo}`,5:`/car/info/car/changeApply/${carNo}`,4:`/monitor/car/changeApply/${carNo}`})[userType], method: 'get' , access:true}],
  
  //['carsLite', { url:(userType) => ({3:`/car/info/queryMap` , 4:`/monitor/queryTreeSearch` , 5:`/enterprise/car/queryMap`})[userType], method:'post',access:true }],


  // ['carReview',{url:'/car/info/check' , method:'post'}],
  ['carReview',{url:(userType) => ({3:'/car/info/check',4:'/monitor/check'})[userType] , method:'post' , access:true}],


  ['carLastCommit',{url:(userType,carNo) => ({3:`/car/info/check/${carNo}`,4:`/monitor/check/${carNo}`})[userType] , method:'get',access:true}],
  // ['carLastCommit',{url:carNo => `/car/info/check/${carNo}` , method:'get'}],

  ['carCommit',{url:id => `/car/info/check/detail/${id}` , method:'get'}],

  //['carLogs', { url: '/car/use/querySelective', method: 'post' }],

  ['carLogs', { url:(userType) =>  ({3:`/car/use/querySelective` ,  5:`/enterprise/car/use/querySelective`})[userType], method:'post',access:true }],



  ['carBills', { url: carId => `/car/billing/record/car/${carId}`, method: 'get' }],
  ['carBillExport', { url: '/car/billing/record/export', method: 'post' , responseType: 'blob',raw: true }],
  
  ['carBillingEnable', { url: (carId, flag) => flag ? `/car/billing/updateStartBilling/${carId}` : `/car/billing/updateEndBilling/${carId}`, method: 'post' , ignoreData:true }],

  ['carNoSection', { url: (id) => (`/car/number/query/${id}`), method: 'get' }],
  ['carNoSections', { url: '/car/number/queryPage', method: 'post' }],
  ['carNoSectionCreate', { url: '/car/number/create', method: 'post' }],
  ['carUnbindCourier', { url: id => `/car/info/queryBindGroups/${id}`, method: 'get' }],
  ['carBind', { url: id => `/car/info/bind`, method: 'put' }],
  ['carLocation', { url: id => `/car/location/detail/${id}`, method: 'get' }],


  ['parts' , {url:id => `/parts/${id}` , method:'get'}],
  ['partses' , {url:`/parts/queryPage` , method:'post',clear:'search'}],
  ['partsUpdate' , {url:`/parts` , method:'put'}],
  ['partsCreate' , {url:`/parts` , method:'post'}],
  ['partsDelete' , {url:id => `/parts/${id}` , method:'delete'}],
  ['partsToggle' , {url:id => `/parts/display/${id}` , method:'put'}],

  ['device', { url: (id) => (`/device/query/${id}`), method: 'get' }],
  ['devices', { url: '/device/queryPage', method: 'post' , clear:'search'}],
  ['deviceUpdate', { url: '/device/update', method: 'post' }],
  ['deviceCreate', { url: '/device/create', method: 'post' }],
  ['deviceDelete', { url: (id) => (`/device/delete/${id}`), method: 'delete' }],
  ['deviceImport', { url: '/device/imports', method: 'post' }],
  ['deviceCmd' , { url: '/cmd/send', method: 'post' }],
  ['deviceCmdByCarNos' , { url: '/cmd/sendByCarNos', method: 'post' }],
  ['deviceCmdByCompany' , { url: '/cmd/sendByCompany', method: 'post' }],
  ['deviceCmdByCode' , { url: '/cmd/sendByCode', method: 'post' }],
  ['deviceCmdLogs' , { url: '/car/cmdRecord/queryPage', method: 'post' }],
  ['devicesLocation', { url: '/device/location/queryPage', method: 'post' }],
  ['devicesLocationExport', { url: '/device/location/queryExport', method: 'post' }],
  ['deviceLocation', { url: id => `/device/location/last/${id}`, method: 'get' }],

  ['rfidDevice', { url: (id) => (`/device/chip/${id}`), method: 'get' }],
  ['rfidDevices', { url: '/device/chip/page', method: 'post' , clear:'search'}],
  ['rfidDeviceUpdate', { url: '/device/chip/', method: 'put' }],
  ['rfidDeviceCreate', { url: '/device/chip/', method: 'post' }],
  ['rfidDeviceDelete', { url: id => `/device/chip/${id}`, method: 'delete' }],

  ['sim', { url: (id) => (`/sim/${id}`), method: 'get' }],
  ['sims', { url: '/sim/queryPage', method: 'post'}],
  ['simUpdate', { url: '/sim', method: 'put' }],
  ['simCreate', { url: '/sim', method: 'post' }],
  ['simDelete', { url: (id) => (`/sim/${id}`), method: 'delete' }],
  ['simImport', { url: '/sim/imports', method: 'post' }],

  
  ['omCmd' , { url:`/operation/cmd/sendNum`, method: 'post' }],


  ['fence', { url: id => `/fence/${id}`, method: "get" }],
  ['fenceAll', { url: id => `/fence/all`, method: "get" }],
  ['fences', { url: '/fence/querypage', method: "post" }],
  ['fenceUpdate', { url: '/fence', method: 'put' }],
  ['fenceCreate', { url: '/fence', method: 'post' }],
  ['fenceDelete', { url: (id) => (`/fence/${id}`), method: 'delete' , ignoreData:true  }],
  ['fenceToggle', { url: (id) => (`/fence/changstate/${id}`), method: 'post' , ignoreData:true }],
  ['fencesView', { url: '/fence/querypage', method: "post"  , data:{pageSize:0 , pageNum:1 , search:{status: 0}}}],
  ['fenceAlarmStats', { url:'/fence/alarm/msg/stats', method:'post'}],
  ['fenceAlarms', { url:'/fence/alarm/msg/queryPage', method:'post'}],
  
  ['invoices', { url: `/car/billing/record/queryPage`, method: 'post' }],
  ['invoice', { url: id => `/car/billing/queryTrade?outTradeNo=${id}`, method: "get" }],

  ['locationRealtime', { url: (carId, id) => (id ? `/car/location/queryRealtime?carId=${carId}&id=${id}` : `/car/location/queryRealtime?carId=${carId}`), method: 'get' }],

  ['locationHistory', { url: (carId, start, end) => `/car/location/queryHistory?carId=${carId}&startDatetime=${start}&endDatetime=${end}`, method: 'get' }],


  ['permission', { url: '/permission/all', method: 'get' }],
  ['file', { url: `/file/query`, method: 'get' }],
  ['impt', { url: '/excelImport/queryPage', method: "post" }],
  ['imptFileDownload', { url: id => `/excelImport/downError/${id}`, method: "post" , responseType: 'blob'}],

  ['statsCar', { url:(userType) => ({3:`/car/mileage/queryPage`,4:`/car/mileage/queryPage`, 5:`/enterprise/car/mileage/queryPage`})[userType], method:'post',access:true }],

  ['statsCourier', { url:(userType) => ({3:`/courier/stats/queryPage`, 4:`/monitor/courier/stats/queryPage`, 5:`/enterprise/courier/stats/queryPage`})[userType], method:'post',access:true }],

  ['statsCourierLicense', { url:'/license/act/stats/courier', method:'post'}],
  ['statsCompanyLicense', { url:'/license/act/stats/company', method:'post'}],
  ['statsLicense', { url:'/license/act/stats/heat', method:'post'}],

  ['statsCompanyViolationExport',{url:'/license/act/stats/company/export' , method:'post', responseType: 'blob',raw: true}],
  ['statsCourierViolationExport',{url:'/license/act/stats/courier/export' , method:'post', responseType: 'blob',raw: true}],

  
  ['organizations',{url:'/organization/queryPage' , method:'post'}],
  ['organization',{url:id => `/organization/${id}` , method:'get'}],
  ['organizationFilter',{url:name => `/organization/queryByName?name=${name}` , method:'get'}],
  ['organizationCreate',{url:'/organization/create' , method:'post'}],
  ['organizationUpdate',{url:'/organization/update' , method:'post'}],
  ['organizationDelete',{url: id=> `/organization/${id}` , method:'delete'}],

  ['orgUsers',{url:'/uc/organization/user/queryPage' , method:'post'}],
  ['orgUser',{url:id => `/uc/organization/user/${id}` , method:'get'}],
  ['orgUserCreate',{url:'/uc/organization/user/add' , method:'post'}],
  ['orgUserUpdate',{url:'/uc/organization/user/update' , method:'post'}],
  ['orgUserDelete',{url: id=> `/uc/organization/user/${id}` , method:'delete'}],
  ['orgUserToggle',{url:'/uc/organization/user/updateStatus' , method:'post'}],

  ['ruleQuery', { url: `/car/billing/rules/queryPage`, method: 'post' }],
  ['ruleCreate', { url: `/car/billing/rules/`, method: 'post' }],
  ['ruleDetail', { url: id => `/car/billing/rules/${id}`, method: 'get' }],
  ['ruleUpdateState', { url: id => `/car/billing/rules/updateState/${id}`, method: 'get' }],
  ['ruleKV', { url: cType => `/configKv/${cType}`, method: 'get' }],

  ['brandCreate', { url: `/brand`, method: 'post' }],
  ['brandQuery', { url: `/brand/queryPage`, method: 'post' }],
  ['brandDetail', { url: id => `/brand/${id}`, method: 'get' }],
  ['brandUpdate', { url: `/brand`, method: 'put' }],
  ['brandDelete', { url: id => `/brand/${id}`, method: 'delete' }],
  ['brandType', { url: type => `/brand/type/${type}`, method: 'get' }],

  ['appVer', { url: id => `/version/${id}`, method: 'get' }],
  ['appVers', { url: `/version/queryPage`, method: 'post' }],
  ['appVerCreate', { url: '/version', method: 'post' }],
  ['appVerUpdate', { url: '/version', method: 'put' }],
  ['appVerToggle', { url: id => `/version/release/${id}`, method: 'put' }],

  ['ticket', { url: id => `/feedback/${id}`, method: 'get' }],
  ['tickets', { url: `/feedback/queryPage`, method: 'post' }],
  ['ticketDeal', { url:id => `/feedback/deal/${id}`, method: 'put' }],


  ['notice', { url: id => `/notice/${id}`, method: 'get' }],
  ['notices', { url: `/notice/queryPage`, method: 'post' }],
  ['noticeCreate', { url: '/notice', method: 'post' }],
  ['noticeUpdate', { url: '/notice', method: 'put' }],
  ['noticeDelete', { url: id => `/notice/${id}`, method: 'delete' }],
  ['messageCount', { url: '/messageRecord/queryNum', method: 'post' , data:{module:5}}],

  
  ['fenceAlarmMsgCreate', { url: `/fence/alarm/msg/create`, method: 'post' }],
  ['fenceAlarmMsgQueryId', { url: id => `/fence/alarm/msg/query/${id}`, method: 'get' }],
  ['fenceAlarmMsgQueryPage', { url: `/fence/alarm/msg/queryPage`, method: 'post' }],
  ['fenceAlarmMsgUpdate', { url: `/fence/alarm/msg/update`, method: 'put' }],

  ['carLicenseApplyInfoPost', { url: `/car/LicenseApply/info`, method: 'post' }],
  ['carLicenseApplyInfoPut', { url: `/car/LicenseApply/info`, method: 'put' }],
  ['carLicenseApplyInfoGet', { url: id => `/car/LicenseApply/info/${id}`, method: 'get' }],
  ['carLicenseApplyInfoDelete', { url: id => `/car/LicenseApply/info/${id}`, method: 'delete' }],
  ['carLicenseApplyInfoChoice', { url: companyId => `/car/LicenseApply/info/choice/${companyId}`, method: 'get' }],
  ['carLicenseApplyInfoDetails', { url: id => `/car/LicenseApply/info/details/${id}`, method: 'get' }],
  ['carLicenseApplyInfoQueryPage', { url: `/car/LicenseApply/info/queryPage`, method: 'post' }],

  ['messages',{url:'/messageRecord/queryList' , method:'post'}],
  ['message',{url:id => `/messageRecord/${id}`, method:'get'}],

  ['informationPut',{url: `/information`, method:'put'}],
  ['informationGet',{url: id => `/information/${id}`, method:'get'}],
  ['informationDelete',{url: id => `/information/${id}`, method:'delete'}],
  ['informationClose',{url: id => `/information/close/${id}`, method:'put'}],
  ['informationCommit',{url: id => `/information/commit/${id}`, method:'put'}],
  ['informationInsert',{url: `/information/insert`, method:'post'}],
  ['informationQuerypage',{url: `/information/querypage`, method:'post'}],
  ['informationReview',{url: `/information/review`, method:'post'}],
  ['informationUncommit',{url: id => `/information/uncommit/${id}`, method:'put'}],
  ['informationLog',{url: id => `/information/log/${id}`, method:'get'}],
  
  ['assBranchs',{url:'/repair/site/queryPage' , method:'post'}],
  ['assBranch',{url:id => `/repair/site/${id}` , method:'get'}],
  ['assBranchsAll',{url:'/repair/site/all' , method:'get'}],
  ['assBranchUpdate',{url: '/repair/site' , method:'put'}],
  ['assBranchCreate',{url: '/repair/site' , method:'post'}],
  ['assBranchDelete',{url: id => `/repair/site/${id}` , method:'delete'}],
  ['assBranchToggle',{url: `/repair/site/state` , method:'put'}],
  ['assBranchCurrent',{url:'/repair/site/self' , method:'get'}],

  

  ['assEmpolyees',{url:'/uc/repair/user/queryPage' , method:'post'}],
  ['assEmpolyee',{url: id => `/uc/repair/user/${id}` , method:'get'}],
  ['assEmpolyeeUpdate',{url: '/uc/repair/user' , method:'put'}],
  ['assEmpolyeeCreate',{url: '/uc/repair/user' , method:'post'}],
  ['assEmpolyeeDelete',{url: id => `/uc/repair/user/${id}` , method:'delete'}],
  ['assEmpolyeeMode',{url: `/uc/repair/user/model` , method:'put'}],
  ['assEmpolyeesToggle',{url: '/uc/repair/user/state' , method:'put'}],
  ['assEmpolyeesBySite',{url: id => `/uc/repair/user/site/${id}` , method:'get'}],

  ['assTickets',{url:'/repair/order/queryPage' , method:'post'}],
  ['assTicket',{url:id => `/repair/order/${id}` , method:'get'}],
  ['assTicketAssign',{url:'/repair/order/distribute' , method:'post'}],
  ['assTicketQueryStats',{url:'/repair/order/queryStats' , method:'post'}],

  ['assBranchsAll',{url:'/repair/site/all' , method:'get'}],
  ['assBranchUpdate',{url: '/repair/site' , method:'put'}],
  ['assBranchCreate',{url: '/repair/site' , method:'post'}],
  ['assBranchDelete',{url: id => `/repair/site/${id}` , method:'delete'}],
  ['assBranchToggle',{url: `/repair/site/state` , method:'put'}],


  ['assFeeTpls',{url:'/repair/ArrivalFee/queryPage' , method:'post'}],
  ['assFeeTpl',{url: id => `/repair/ArrivalFee/${id}` , method:'get'}],
  ['assFeeTplUpdate',{url: '/repair/ArrivalFee' , method:'put'}],
  ['assFeeTplCreate',{url: '/repair/ArrivalFee' , method:'post'}],
  ['assFeeTplDelete',{url: id => `/repair/ArrivalFee/${id}` , method:'delete'}],

  ['assUsers',{url:'/uc/user/repair/site/queryPage' , method:'post'}],
  ['assUser',{url: id => `/uc/user/repair/site/${id}` , method:'get'}],
  ['assUserUpdate',{url: '/uc/user/repair/site' , method:'put'}],
  ['assUserCreate',{url: '/uc/user/repair/site' , method:'post'}],
  ['assUserDelete',{url: id => `/uc/user/repair/site/${id}` , method:'delete'}],
  ['assUserToggle',{url: `/uc/user/repair/site/state` , method:'put'}],

  ['assPartsCates',{url:'/parts/category/queryPage' , method:'post'}],
  ['assPartsCate',{url: id => `/parts/category/${id}` , method:'get'}],
  ['assPartsCateUpdate',{url: '/parts/category' , method:'put'}],
  ['assPartsCateCreate',{url: '/parts/category' , method:'post'}],
  ['assPartsCateDelete',{url: id => `/parts/category/${id}` , method:'delete'}],
  ['assPartsCateToggle',{url: '/parts/category/state' , method:'put'}],

  ['assSuppliers',{url:'/supplier/queryPage' , method:'post'}],
  ['assSupplier',{url: id => `/supplier/query/${id}` , method:'get'}],
  ['assSupplierUpdate',{url: '/supplier/update' , method:'put'}],
  ['assSupplierCreate',{url: '/supplier/create' , method:'post'}],
  ['assSupplierDelete',{url: id => `/supplier/delete/${id}` , method:'delete'}],
  ['assSupplierSelect',{url: '/supplier/selectIdName' , method:'get'}],

  ['assPartsGoodses',{url:'/parts/goods/queryPage' , method:'post'}],
  ['assPartsGoods',{url: id => `/parts/goods/${id}` , method:'get'}],
  ['assPartsGoodsUpdate',{url: '/parts/goods' , method:'put'}],
  ['assPartsGoodsCreate',{url: '/parts/goods' , method:'post'}],
  ['assPartsGoodsDelete',{url: id => `/parts/goods/${id}` , method:'delete'}],
  ['assPartsGoodsToggle',{url: '/parts/goods/state' , method:'put'}],
  ['assPartsGoodsImport', { url: '/parts/goods/imports', method: 'post' }],
  ['assPartsGoodsExport', { url: '/parts/goods/queryExport', method: 'post', responseType: 'blob',raw: true }],
  ['assPartsCatesAll',{url:'/common/queryPartsCategories' , method:'get'}],


   //['stdApplications',{url:'/standard/apply/queryPage' , method:'post'}],
  // 3 系统管理 4 监管 5 企业 7 维修站点管理员
  //(({3:'/standard/apply/queryPage' , 7:'/repair/standard/install/queryPage'})[userType])
  ['stdInstallations',{url:(userType) => ({3:'/standard/install/queryPage',4:'/standard/install/queryPage', 5:'/standard/install/queryPage', 7:'/repair/standard/install/queryPage'})[userType], method:'post',access:true }],

  ['stdInstallation',{url: (userType , id) => ({3:`/standard/install/${id}`,4:`/standard/install/${id}`,5:`/standard/install/${id}`, 7:`/repair/standard/install/${id}`})[userType], method:'get',access:true}],

  ['stdInstallationAssign',{url:(userType) => ({3:'/standard/install/assign' , 7:'/repair/standard/install/assign'})[userType], method:'post',access:true}],
  ['stdInstallationUnassign',{url:(userType,id) => ({3:`/standard/install/assign/cancel/${id}` , 7:`/repair/standard/install/assign/cancel/${id}`})[userType], method:'put',access:true}],

  ['stdInstallationReview',{url: '/standard/install/review' , method:'post'}],
  ['stdInstallationCancel', { url: id => `/standard/install/apply/${id}`, method: 'delete' }],
  ['stdInstallationLog', { url: id => `/standard/install/log/${id}`, method: 'get'}],
  ['stdInstallationCreate',{url:'/standard/install/apply' , method:'post'}],
  ['stdInstallationConfirm',{url:'/standard/install/confirm' , method:'post'}],
  ['stdInstallationExport',{url:'/standard/install/export' , method:'post', responseType: 'blob',raw: true}],


  ['stdApplications',{url:'/standard/apply/queryPage' , method:'post'}],
  ['stdApplication',{url: id => `/standard/apply/${id}` , method:'get'}],
  ['stdApplicationCancel', { url: id => `/standard/apply/cancel/${id}`, method: 'delete' }],
  ['stdApplicationCreate',{url: '/standard/apply' , method:'post'}],
  ['stdApplicationInfo',{url: id => `/standard/apply/install/${id}` , method:'get'}],

  ['stdCars',{url:'/standard/car/queryPage' , method:'post'}],
  ['stdCar',{url: id => `/standard/car/${id}` , method:'get'}],

  ['stdCarLog',{url: id => `/standard/car/log/${id}` , method:'get'}],
  ['stdCarReview',{url:'/standard/car/check' , method:'post'}],
  ['stdCarReviewMore',{url: '/standard/car/recheck' , method:'post'}],
  ['stdCarCreate',{url: '/standard/car' , method:'post'}],
  ['stdCarUpdate',{url: '/standard/car' , method:'put'}],
  ['stdCarCancel', { url: id => `/standard/car/cancel/${id}`, method: 'get' }],
  ['stdCarInstallation',{url: id => `/standard/car/install/${id}` , method:'get'}],
  ['stdCarExport',{url:'/standard/car/export' , method:'post', responseType: 'blob',raw: true}],


  ['standardProgressReportPage',{url:'/standard/progress/report/page' , method:'post'}],
  ['standardProgressReportChart',{url: `/standard/progress/report/chart` , method:'post'}],
  ['standardProgressReportExport',{url: `/standard/progress/report/export` , method:'post', responseType: 'blob',raw: true}],

  ['standardExport',{url: `/standard/export` , method:'post', responseType: 'blob',raw: true}],
  ['standardQueryPage',{url: `/standard/queryPage` , method:'post'}],
  ['standardChart',{url: `/standard/chart` , method:'post'}],

  ['partnerUsers',{url:'/uc/user/cooperative/queryPage' , method:'post'}],
  ['partnerUser',{url: id => `/uc/user/cooperative/${id}` , method:'get'}],
  ['partnerUserUpdate',{url: '/uc/user/cooperative' , method:'put'}],
  ['partnerUserCreate',{url: '/uc/user/cooperative' , method:'post'}],
  ['partnerUserDelete',{url: id => `/uc/user/cooperative/${id}` , method:'delete'}],
  ['partnerUserToggle',{url: (id) => `/uc/user/cooperative/state` , method:'put'}],
  ['partnerUserUnlock',{url: id => `/uc/user/cooperative/lock/${id}` , method:'put'}],

  ['partners',{url:'/cooperative/company/info/queryPage' , method:'post'}],
  ['partner',{url: id => `/cooperative/company/info/${id}` , method:'get'}],
  ['partnerUpdate',{url: '/cooperative/company/info' , method:'put'}],
  ['partnerCreate',{url: '/cooperative/company/info' , method:'post'}],
  ['partnerDelete',{url: id => `/cooperative/company/info/${id}` , method:'delete'}],
  ['partnerToggle',{url: (id , enable) => `/cooperative/company/info/update/enable/${id}/${enable}` , method:'put'}],
  ['partnerSelect',{url: '/cooperative/company/info/query/choices' , method:'get'}],

  ['partnerCars',{url:'/coo/car/queryPage' , method:'post'}],
  ['partnerCar',{url: carNo => `/coo/car/detail/${carNo}` , method:'get'}],
  ['partnerCarInvoices',{url:`/coo/car/bill/record/queryPage` , method:'post'}],
  ['partnerCarFinance',{url: carNo => `/coo/car/bill/${carNo}` , method:'get'}],
  ['partnerCarInsurance',{url: carNo => `/coo/car/insurance/${carNo}` , method:'get'}],
  ['partnerCarLogs',{url:'/coo/car/bind/queryPage', method:'post'}],

  ['insurances',{url:'/insurance/info/queryPage' , method:'post'}],
  ['insurance',{url: id => `/insurance/info/${id}` , method:'get'}],
  ['insuranceUpdate',{url: '/insurance/info' , method:'put'}],
  ['insuranceCreate',{url: '/insurance/info' , method:'post'}],
  ['insuranceDelete',{url: id => `/insurance/info/${id}` , method:'delete'}],
  ['insuranceToggle',{url: (id , enable) => `/insurance/info/update/enable/${id}/${enable}` , method:'put'}],
  ['insuranceSelect',{url: '/insurance/info/query/choices' , method:'get'}],

  ['insuranceReminders',{url:'/car/carInsuranceWarn/queryPage' , method:'post'}],

  ['installments', { url: `/car/billing/rules/queryPage`, method: 'post' }],
  ['installmentCreate', { url: `/car/billing/rules/`, method: 'post' }],
  ['installmentDelete', { url: id => `/car/billing/rules/${id}`, method: 'delete' }],
  ['installment', { url: id => `/car/billing/rules/${id}`, method: 'get' }],
  ['installmentToggle', { url: id => `/car/billing/rules/updateState/${id}`, method: 'get' }],

  ['logisticsId',{url: (id)=>`/logistics/${id}` , method:'get'}],
  ['logisticsImports',{url: `/logistics/imports` , method:'post'}],
  ['logisticsLoction',{url: (id)=>`/logistics/loction/${id}` , method:'get'}],
  ['logisticsQueryPage',{url: `/logistics/queryPage` , method:'post'}],


  ['logisticsPaths',{url:'/logistics/path/page' , method:'post'}],
  ['logisticsPath',{url: id => `/logistics/path/${id}` , method:'get'}],
  ['logisticsPathTask',{url: id => `/logistics/path/point/${id}` , method:'get'}],
  

  ['examQuestions',{url:'/exam/questions/queryPage' , method:'post'}],
  ['examQuestion',{url:id => `/exam/questions/${id}` , method:'get'}],
  ['examQuestionCreate',{url:'/exam/questions/create' , method:'post'}],
  ['examQuestionUpdate',{url:'/exam/questions/update' , method:'post'}],
  ['examQuestionDelete',{url: id=> `/exam/questions/${id}` , method:'delete'}],
  
  ['examTpls',{url:'/exam/template/queryPage' , method:'post'}],
  ['examTpl',{url:id => `/exam/template/${id}` , method:'get'}],
  ['examTplCreate',{url:'/exam/template/create' , method:'post'}],
  ['examTplUpdate',{url:'/exam/template/update' , method:'post'}],
  ['examTplDelete',{url: id=> `/exam/template/${id}` , method:'delete'}],
  ['examTplFilter',{url: `/exam/template/queryByArea` , method:'post'}],

  
  ['examVideos',{url:'/exam/video/queryPage' , method:'post'}],
  ['examVideo',{url:id => `/exam/video/${id}` , method:'get'}],
  ['examVideoCreate',{url:'/exam/video/create' , method:'post'}],
  ['examVideoUpdate',{url:'/exam/video/update' , method:'post'}],
  ['examVideoDelete',{url: id => `/exam/video/${id}` , method:'delete'}],
  ['examVideoToggle',{url:'/exam/video/updateState' , method:'post'}],
  ['examVideoUpload',{url:'/exam/video/createVideo' , method:'post'}],

  ['examCategories',{url:'/exam/category/queryAll' , method:'get'}],

  ['carChangeSummaryQueryPage',{url:'/car/change/summary/queryPage' , method:'post'}],
  ['carChangeChart',{url:'/car/change/chart' , method:'post'}],
  ['carChangeDetail',{url: companyId => `/car/change/detail/${companyId}` , method:'get'}],

  ['licenses',{url:'/license/queryPage' , method:'post'}],
  ['license',{url:id => `/license/${id}` , method:'get'}],
  ['licenseCreate',{url:'/license' , method:'post'}],
  ['licenseUpdate',{url:'/license' , method:'put'}],
  ['licenseDelete',{url: id=> `/license/${id}` , method:'delete'}],
  ['licenseToggle',{url:id=>`/license/state/${id}` , method:'put'}],
  ['licenseAll',{url:`/license/all` , method:'get'}],

  ['licenseRules',{url:'/license/rule/queryPage' , method:'post'}],
  ['licenseRule',{url:id => `/license/rule/${id}` , method:'get'}],
  ['licenseRuleCreate',{url:'/license/rule' , method:'post'}],
  ['licenseRuleUpdate',{url:'/license/rule' , method:'put'}],
  ['licenseRuleDelete',{url: id=> `/license/rule/${id}` , method:'delete'}],

  ['licenseViolations',{url:'/license/act/record/queryPage' , method:'post'}],
  ['licenseViolation',{url:id => `/license/act/record/${id}` , method:'get'}],
  ['licenseViolationCreate',{url:'/license/act/record' , method:'post'}],
  ['licenseViolationUpdate',{url:'/license/act/record' , method:'put'}],
  ['licenseViolationCancel',{url: id=> `/license/act/record/cancel/${id}` , method:'put'}],
  ['licenseViolationReview',{url: id=> `/license/act/record/review` , method:'put'}],
  ['licenseViolationExport',{url:'/license/act/record/export' , method:'post', responseType: 'blob',raw: true}],

  ['licenseExamRecord',{url:id => `/exam/record/${id}` , method:'get'}],
  ['licenseExamRecords',{url:'/exam/record/queryPage' , method:'post'}],
  ['licenseExamRecordReview',{url:'/exam/record/review' , method:'put'}],
  ['licenseExamTpl',{url:id=>`/exam/record/template/${id}`,method:'get'}],
  ['licenseExamRecordExport',{url:id => `/exam/record/${id}` , method:'get'}],
  ['licenseExamRecordRelease',{url:id => `/exam/record/release/${id}`, method:'put'}],
  ['licenseInstanceByRecordId',{url: examRecordId => `/exam/record/cert/${examRecordId}` , method:'get'}],

  ['licenseExceptions',{url:'/license/act/register/queryPage' , method:'post'}],
  ['licenseException',{url:id => `/license/act/register/${id}` , method:'get'}],
  ['licenseExceptionCreate',{url:'/license/act/register' , method:'post'}],
  ['licenseExceptionUpdate',{url:'/license/act/register' , method:'put'}],
  ['licenseExceptionCancel',{url: id=> `/license/act/register/cancel/${id}` , method:'put'}],
  ['licenseExceptionExport',{url:'/license/act/register/export' , method:'post', responseType: 'blob',raw: true}],


  ['policemen',{url:'/uc/org/police/queryPage' , method:'post'}],
  ['policeman',{url:id => `/uc/org/police/${id}` , method:'get'}],
  ['policemanCreate',{url:'/uc/org/police' , method:'post'}],
  ['policemanUpdate',{url:'/uc/org/police' , method:'put'}],
  ['policemanDelete',{url: id => `/uc/org/police/${id}` , method:'delete'}],
  ['policemanToggle',{url: id => `/uc/org/police/state` , method:'put'}],
  ['policemanImport',{url: `/uc/org/police/imports` , method:'post'}],

  // ['operationalWarnings',{url:'/license/queryPage' , method:'post'}],
  // ['operationalWarning',{url:id => `/license/${id}` , method:'get'}],
  // ['operationalWarningCreate',{url:'/license' , method:'post'}],
  // ['operationalWarningUpdate',{url:'/license' , method:'put'}],
  // ['operationalWarningDelete',{url: id=> `/license/${id}` , method:'delete'}],
  // ['operationalWarningToggle',{url:id=>`/license/state/${id}` , method:'put'}],

  //逾期统计
  ['statsOverdueCompany',{url:'/car/arrears/company' , method:'post'}],
  ['statsOverdueCar', { url:'/car/arrears/courier', method:'post'}],
  
  ['companyWarningRecords',{url:'/company/warn/record/queryPage' , method:'post'}],
  ['companyWarningRecord',{url:'/company/warn/record/detail/page' , method:'post'}],
  ['statsCompanyWarning', { url:'/company/warn/record/stats', method:'post'}],

  ['statsCompaniesCarWarning', { url:'/company/warn/record/stats/company/page', method:'post'}],
  ['statsCompanyCarWarning', { url: '/company/warn/record/stats/company/car', method:'post'}],

  ['statsBrands', { url:'/company/warn/record/stats/brand', method:'post'}],
  ['statsBrand', { url:'/company/warn/record/stats/brand/detail', method:'post'}],

  ['statsBrandsInsurance', { url:'/stats/brand/insurance', method:'post'}],
  ['statsBrandInsurance', { url:'/stats/brand/insurance/company', method:'post'}],

  ['statsBrandsTrain', { url:'/stats/license/brand', method:'post'}],
  ['statsCompanyTrain', { url:'/stats/license/company', method:'post'}],

  
  ['screenCarInCompany',{url:id => `/screen/company/car/${id}` , method:'get'}],
  ['screenCourierInCompany',{url:id => `/screen/company/courier/${id}` , method:'get'}],
  ['screenCompanySummary',{url:id => `/screen/company/summary/${id}` , method:'get'}],
  ['screenCarStats',{url:id => `/screen/car/stats` , method:'get'}],

  ['screenCompanyMap',{url:'/screen/company/map' , method:'post'}],
  ['screenCarMap',{url:'/screen/car/map' , method:'post'}],
  ['screenCarMapLive',{url:'/screen/car/map/history', method:'post'}],

  ['battery',{url:id => `/battery/query/${id}`,method:'GET'}],
  ['batteryAlarms',{url:'/battery/alarm/queryPage',method:'POST'}],
  ['batteryAlarm',{url: id => `/battery/alarm/query/${id}`,method:'GET'}],
  ['batteryToggle',{url: id=> `/battery/bms/switch/${id}`,method:'PUT'}],
  ['batteryAlarmType',{url: '/battery/alarm/type',method:'GET'}],

  
  ['deposits',{url:'/shop/cashPledge/queryPage',method:'post'}],
  ['depositCreate',{url:'/shop/cashPledge/add',method:'post'}],
  ['depositDelete',{url:id => `/shop/cashPledge/${id}`,method:'delete'}],
  ['depositToggle',{url:id => `/shop/cashPledge/state/${id}` , method:'put'}],



  ['goodses',  {url:'/goods/queryPage',method:'post'}],
  ['goods' , {url:(id)=>(`/goods/${id}`),method:'get'}],
  ['goodsCreate',  {url:'/goods/create',method:'post'}],
  ['goodsUpdate',  {url:'/goods/update',method:'post'}],
  ['goodsCate',  {url:'/goods/category/0',method:'get'}],
  ['goodsDelete',{url:(id)=>(`/goods/${id}`),method:'delete'}],
  ['goodsFile',{url:(id) => `/goods/file/queryImg?id=${id}`,method:'get',responseType: 'blob', raw: true}],
  ['goodsFileUpload',{url:'/goods/file/upload',method:'post'}],
  ['goodsToggle',{url:'/goods/updateStates',method:'post'}],

  ['goodsSkus',{url:id => `/goods/sku/${id}`, method:'get'}],

  ['specifications',  {url:categoryId=>`/goods/spec/${categoryId}`,method:'get'}],
  ['specificationsByGoods',  {url:categoryId=>`/goods/spec/${categoryId}`,method:'get'}],

  ['sku' , {url:(id)=>(`/goods/sku/${id}`),method:'get'}],
  ['skus' , {url:'/goods/sku/queryPage',method:'post'}],
  ['skuCreate' , {url:'/goods/sku/create',method:'post'}],
  ['skuUpdate' , {url:'/goods/sku/update' , method:'post'}],
  ['skuUpdateStatus' , {url:'/goods/sku/updateStatus' , method:'post'}],
  ['skuDelete' , {url:(id)=>`/goods/sku/${id}` , method:'delete'}],
  ['skuQuery' , {url:(id)=>(`/goods/sku/skuId/${id}`),method:'get'}],
  ['skuFinance' , {url:(id)=>(`/good/finance/sku/${id}`),method:'get'}],
  ['skusFinance' , {url:'/good/finance/queryBySkuIds',method:'post'}],

  ['skuFinanceDetail' , {url:'/good/finance/querySkuFinancePrice',method:'get'}],
  
  ['skuFinanceCreate' , {url:`/good/finance/insert`,method:'post'}],
  ['skuFinanceDelete' , {url:(id)=>`/good/finance/${id}`,method:'delete'}],

  ['order',  {url:(id)=>(`/order/${id}`),method:'get'}],
  ['orders',  {url:'/order/queryPage',method:'post'}],
  ['orderUpdate',  {url:'/order/update',method:'post'}],
  ['orderCancel',  {url:'/order/updateStateForCancel',method:'post'}],
  ['orderConfirm',  {url:'/order/updateStateForConfirm',method:'post'}],
  ['orderValidate',  {url:'/order/updateStateForExamine',method:'post'}],
  ['orderReject',  {url:'/order/updateStateForReject',method:'post'}],
  ['orderReceive',  {url:'/order/updateStateForReceived',method:'post'}],
  ['orderSign',  {url:'/order/updateStateForSign',method:'post'}],
  ['orderFileUpload',  {url:'/order/annex/createFile',method:'post'}],

  ['orderCompanyQuery',  {url:(id)=>(`/order/company/orderId/${id}`),method:'get'}],
  ['orderCompanyUpdate',  {url:'/order/company/update',method:'post'}],
  ['orderFinanceQuery',  {url:(id)=>(`/order/finance/orderId/${id}`),method:'get'}],
  ['orderInstallment',  {url:id => `/order/finance/detail/orderId/${id}`,method:'get'}],

  ['orderFinanceIntersection',  {url:`/order/finance/queryIntersection`,method:'get'}],
  ['orderFinanceUpdate',  {url:'/order/finance/update',method:'post'}],
  ['orderInsuranceQuery',  {url:(id)=>(`/order/insurance/orderId/${id}`),method:'get'}],
  ['orderInsuranceUpdate',  {url:'/order/insurance/update',method:'post'}],
  ['orderBuyerQuery',  {url:(id)=>(`/order/buyer/orderId/${id}`),method:'get'}],
  ['orderBuyerUpdate',  {url:'/order/buyer/update',method:'post'}],
  ['orderGoodsQuery',  {url:(id)=>(`/order/goods/orderId/${id}`),method:'get'}],
  ['orderGoodsUpdate',  {url:'/order/goods/update',method:'post'}],
  ['orderLogisticsQuery',  {url:(id)=>(`/order/logistics/order/${id}`),method:'get'}],
  ['orderLogisticsUpdate',  {url:'/order/logistics/update',method:'post'}],

  ['orderApplyLoan',  {url:'/order/updateStateForApplyLoan',method:'post'}],
  ['orderPushNotify',  {url:'/order/updateStateForPush',method:'post'}],

  
  ['orderPersons',  {url:id => `/order/personal/order/${id}`,method:'get'}],
  ['orderPerson',  {url:id => `/order/personal/${id}`,method:'get'}],
  ['orderPersonCreate',  {url:'/order/personal/create',method:'post'}],
  ['orderPersonUpdate',  {url:'/order/personal/update',method:'post'}],
  ['orderPersonDelete',  {url:id => `/order/personal/${id}`,method:'delete'}],
  ['personAnnex',  {url:id => `/personal/annex/queryImg`,method:'get'}],
  ['personAnnexUpload',  {url:`/personal/annex/createFile`,method:'post'}],
  
  ['orderAnnexUpload', {url:'/order/annex/',method:'put'}],
  ['orderAnnexDelete', {url:(id)=>(`/order/annex/${id}`),method:'delete'}],
  ['orderAnnex', {url:(id)=>(`/order/annex/queryImg?id=${id}`),method:'get'}],

  ['enterpriseFilter',  {url:'/credit/enterprise/base/selectBlur',method:'post'}],
  ['enterpriseValidate',  {url: (id , orderId) => `/credit/enterprise/base/perfect?id=${id}&orderId=${orderId}`,method:'get'}],
  // 
]